import './style.scss';

const Logo = (props) => (
  // <img
  //   className="logo"
  //   alt="Logo"
  //   // src=""
  //   // src="/static/icon-ccn_logo.svg"
  //   {...props}
  // />
  <></>
);

export default Logo;
